<script>
export default {
    data() {
        return {
            model: {
                address: null,
                companies: [],
            },
        }
    },

    mounted() {
        this.$store.dispatch('title', this.$t('ADDRESSES.NEW'))
    },
    methods: {
        save() {
            this.$store.dispatch('addressCreate', this.model).then(() => {
                this.$router.go(-1)
            })
        },

        addCompany(model) {
            this.model.companies.push(model)
        },

        delCompany(model) {
            this.model.companies.splice(
                this.model.companies.findIndex((x) => x.id == model.id),
                1
            )
        },
    },
}
</script>

<template lang="pug">
acrm-panel
    acrm-heading(:level="5") {{ $t('ADDRESSES.BASEDATA')}}

    acrm-input-google-autocomplete(v-model="model.address" :placeholder="$t('ADDRESSES.ADDRESS')")

    acrm-heading.mt-3(:level="5") {{ $t('ADDRESSES.ADD_COMPANY_1') }}
    acrm-company-select(@input="addCompany")

    acrm-setting-list-table(
    :label="$t('ADDRESSES.ADDED_COMPANIES')")

    acrm-setting-list-table(
    v-if="model.companies[0]"
    :label="$t('ADDRESSES.ADDED_COMPANIES')"
    :data-array="model.companies"
    :attributes="['name']"
    :translation="['COMPANIES.NAME']"
    @delete="delCompany")

    hr
    .row
        .col-12.col-md-auto.ml-auto
            acrm-input-button.block-md-down(variant="light" @click="$router.go(-1)") {{ $t('BASE.BACK')}}
        .col-12.col-md-auto
            acrm-input-button.block-md-down(variant="success" @click="save") {{ $t('BASE.CREATE')}}
</template>
